// NewCompany.js
import React, { Fragment, useEffect, useState } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Row,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Breadcrumbs, Btn, H3 } from "../../../AbstractElements";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Typeahead from "../../../CommonElements/TypeAhead";
import asiaTimezones from "../../Common/Timezone/Timezone";
import moment from "moment";

import {
  getClientUrlDataToken,
  getMasterDataToken,
  postMasterToken,
  postClientUrlWithToken,
  PostMasterDataToken,
  postDataWithToken,
} from "../../../Utils/restUtils";
import {
  addSetupCost,
  CompanyAdd,
  getclientpackage,
  getCurrency,
} from "../../../CommonURL";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
// import Transparentspinner from "../../../Common/Loader/Transparentspinner";
// import HandleHomePageError from "../../../Common/ErrorImport/SignError";
// import HandleApiError from "../../../Common/ErrorImport/ErrorImport";

import { duedateOptions } from "./dueDate";
// import {
//   AfterNo,
//   BeforeNo,
//   Comma,
//   Dash,
//   DateOne,
//   DateTwo,
//   DateThree,
//   DateFour,
//   DateFive,
//   DateSix,
//   Decimal as DecimalLabel,
//   Dot,
//   FinancialYearStart,
//   PerPosition,
//   Separator,
//   TimeZone,
//   DefaultCurrency,
//   DefaultLang,
// } from "../../../Constant";

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  name: yup.string().required("Name is required"),
  phone: yup.string().required("Phone number is required"),
});

const NewCompany = () => {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ resolver: yupResolver(validationSchema) });

  const [logoFile, setLogoFile] = useState(null);
  const [iconFile, setIconFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [iconPreview, setIconPreview] = useState(null);
  const [financialDate, setFinancialDate] = useState(null);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [createdCompanyId, setCreatedCompanyId] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [packageOptions, setPackageOptions] = useState([]);
  const [industryTypeId, setIndustryTypeId] = useState(null);
  const [companyId, setCompanyId] = useState(null);

  const authState = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const languageOptions = [{ value: "english", label: "ENGLISH (GB)" }];
  const { state } = useLocation();
  const user_id = state?.bq_user_id;

  const dateFormat = [
    { value: "d M Y", label: "DD MMM YYYY" },
    { value: "M d Y", label: "MMM DD YYYY" },
    { value: "Y M d", label: "YYYY MMM DD" },
    { value: "d m Y", label: "DD MM YYYY" },
    { value: "m d Y", label: "MM DD YYYY" },
    { value: "Y m d", label: "YYYY MM DD" },
  ];

  const dateSeperator = [
    { value: "-", label: "-" },
    { value: "/", label: "/" },
    { value: ".", label: "." },
    { value: ",", label: "," },
    { value: " ", label: "Space" },
  ];

  const percentPosition = [
    { value: "after", label: "After" },
    { value: "before", label: "Before" },
  ];

  const decimaloptions = [
    { value: "2", label: "0.00" },
    { value: "3", label: "0.000" },
    { value: "4", label: "0.0000" },
  ];

  useEffect(() => {
    loadCurrencyOptions();
  }, []);

  const loadCurrencyOptions = async () => {
    try {
      const res = await getMasterDataToken(getCurrency);

      if (res?.status === 200) {
        const transformed = res.data?.data?.map((item) => ({
          label: item.name,
          value: item.code,
        }));
        setCurrencyOptions(transformed);

        const defaultCurrency =
          transformed.find((c) => c.value === "INR") || transformed[0];
        setValue("currency", defaultCurrency);
      }
    } catch (err) {
      setCurrencyOptions([]);
    }
  };

  useEffect(() => {
    const inputs = document.querySelectorAll('input[type="number"]');
    const prevent = (e) => e.preventDefault();
    inputs.forEach((el) => el.addEventListener("wheel", prevent));
    return () =>
      inputs.forEach((el) => el.removeEventListener("wheel", prevent));
  }, []);

  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
      setValue("logo", file);
    }
  };

  const handleIconChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setIconFile(file);
      setIconPreview(URL.createObjectURL(file));
      setValue("icon", file);
    }
  };

  const handleChangeDate = (date) => {
    setFinancialDate(date);
    setValue("financial", date);
    setValue("financialYearStartDate", date);
  };
  const handleConfirmPlan = async () => {
    if (!selectedPlan) {
      toast.error("Please select a subscription plan");
      return;
    }

    try {
      const requestBody = {
        package_id: selectedPlan.value,
        company_id: createdCompanyId,
        user_id: user_id,
        created_admin: "1",
      };

      const response = await postDataWithToken(addSetupCost, requestBody);

      if (response?.data?.status === true) {
        if (response?.data?.data === "free") {
          navigate(`${process.env.PUBLIC_URL}/subscriptions/active-sub`);
        } else {
          navigate(
            `${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?order_id=${response?.data?.data?.order_id}`
          );
        }
      } else {
        alert(" Try again.");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("Something went wrong!");
    }
    setShowPlanModal(false);
  };

  const loadPackages = async (industryTypeId) => {
    try {
      const Postreq = {
        industry_type_id: industryTypeId,
        user_id: user_id,
      };

      const res = await postMasterToken(getclientpackage, Postreq);

      if (res?.data?.status === true) {
        const packages = res.data.data.packages || [];

        const transformed = packages.map((pkg) => ({
          label: pkg.name,
          value: pkg.id,
          fullData: pkg,
        }));

        setPackageOptions(transformed);
      }
    } catch (err) {
      toast.error("Failed to load packages");
    }
  };

  const onSubmit = async (data) => {
    const countryCode = data.countryCode || getValues("countryCode") || "";
    const mobile = data.phone || getValues("phone") || "";

    if (!mobile || !countryCode) {
      toast.error("Please provide a valid phone number with country code.");
      return;
    }

    setLoading(true);
    const form = new FormData();
    let phoneno = mobile;
    try {
      if (countryCode && mobile.startsWith(countryCode))
        phoneno = mobile.slice(countryCode.length);
    } catch (e) {}
    form.append("user_id", user_id);
    form.append("name", data.name || "");
    form.append("email", data.email || "");
    form.append("phone", phoneno || "");
    form.append("country_code", countryCode || "");
    form.append("address", data.address || "");
    form.append("tax_in", data.taxin || "");
    if (logoFile) form.append("logo", logoFile);
    const formattedFinancial = financialDate
      ? moment(financialDate).format("DD-MM-YYYY")
      : "";
    form.append("financial_year", formattedFinancial);
    form.append("time_zone", data.timezone?.value || "");
    form.append(
      "date_format",
      data.dateFormate?.value || data.dateFormate || ""
    );
    form.append("separator", data.separator?.value || data.separator || "");
    form.append("position", data.position?.value || data.position || "");
    form.append("decimal", data.decimal?.value || data.decimal || "");
    form.append("item_name", data.ItemName?.value || "");
    form.append("price_name", data.PriceName?.value || "");
    form.append(
      "quantity_name",
      data.QuantityName?.value || data.QuantityName || ""
    );
    form.append("invoice_prefix", data.invprefix || "");
    form.append("invoice_suffix", data.invsuffix || "");
    form.append("due_date", data.duedate?.value || data.duedate || "");
    if (iconFile) form.append("icon", iconFile);
    form.append("currency", data.currency?.value || "");
    form.append("language", data.language?.value || "");

    try {
      const res = await postMasterToken(CompanyAdd, form, {});

      if (res.status === 200) {
        if (res.data?.status === true) {
          toast.success(res.data.message || "Company created successfully");
          setCreatedCompanyId(res.data?.data?.id);
          setIndustryTypeId(res.data?.data?.industry_type_id);
          await loadPackages(res.data?.data?.industry_type_id);
          setShowPlanModal(true);
          return;
        } else {
          const msg = res.data?.message;
          if (Array.isArray(msg)) msg.forEach((m) => toast.error(m));
          else toast.error(msg || "Error creating company");
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <Breadcrumbs
        mainTitle="New Company"
        parent="Companies"
        title="Create Company"
      />

      <Card>
        <CardHeader className="pb-0">
          <H3>New Company</H3>
        </CardHeader>

        <CardBody>
          {/* {loading && <Transparentspinner />} */}
          <Form
            className="needs-validation"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="g-3">
              {/* Row 1: Company Name | Email */}
              <Col md="6">
                <Label className="form-label">
                  Company Name <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Company Name"
                  defaultValue=""
                  {...register("name")}
                />
                <span className="text-danger">
                  {errors.name && errors.name.message}
                </span>
              </Col>

              <Col md="6">
                <Label className="form-label">
                  Email <span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  type="email"
                  {...register("email")}
                  placeholder="Email"
                />
                <span className="text-danger">
                  {errors.email && errors.email.message}
                </span>
              </Col>

              {/* Row 2: Phone | GST/Tax No */}
              <Col md="6">
                <Label className="form-label">
                  Phone <span className="requireStar">*</span>
                </Label>
                <Controller
                  name="phone"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"in"}
                      enableSearch={true}
                      onChange={(value, country) => {
                        setValue("countryCode", country.dialCode);
                        field.onChange(value);
                      }}
                      inputStyle={{ width: "100%", height: "38px" }}
                      buttonStyle={{ border: "1px solid #ced4da" }}
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.phone && errors.phone.message}
                </span>
              </Col>

              <Col md="6">
                <Label className="form-label">GST/Tax No</Label>
                <input
                  className="form-control"
                  type="text"
                  {...register("taxin")}
                  placeholder="GST/Tax No"
                />
              </Col>

              {/* Row 3: Address | Timezone */}
              <Col md="6">
                <Label className="form-label">Address</Label>
                <textarea
                  className="form-control"
                  rows="2"
                  {...register("address")}
                  placeholder="Address"
                />
              </Col>

              <Col md="6">
                <Label className="form-label">Time Zone</Label>
                <Controller
                  name="timezone"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <Typeahead
                      options={asiaTimezones}
                      onChange={(v) => field.onChange(v)}
                      value={field.value}
                    />
                  )}
                />
              </Col>

              {/* Row 4: Financial Year | Date Format */}
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label>Financial Year Start</Label>
                  <DatePicker
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/yyyy"
                    selected={financialDate}
                    onChange={handleChangeDate}
                  />
                  <input
                    type="hidden"
                    {...register("financialYearStartDate")}
                    value={financialDate || ""}
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <Label>Date Format</Label>
                  <Controller
                    name="dateFormate"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <Typeahead
                        options={dateFormat}
                        onChange={(v) => field.onChange(v)}
                        value={field.value}
                      />
                    )}
                  />
                </FormGroup>
              </Col>

              {/* Row 5: Date Separator | Percent Position */}
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label>Date Separator</Label>
                  <Controller
                    name="separator"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <Typeahead
                        options={dateSeperator}
                        onChange={(v) => field.onChange(v)}
                        value={field.value}
                      />
                    )}
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <Label>Percent (%) Position</Label>
                  <Controller
                    name="position"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <Typeahead
                        options={percentPosition}
                        onChange={(v) => field.onChange(v)}
                        value={field.value}
                      />
                    )}
                  />
                </FormGroup>
              </Col>

              {/* Row 6: Decimal | Invoice Prefix */}
              <Col md="6">
                <FormGroup className="mb-3">
                  <Label>Decimal</Label>
                  <Controller
                    name="decimal"
                    control={control}
                    render={({ field }) => (
                      <Typeahead
                        options={decimaloptions}
                        onChange={(v) => field.onChange(v)}
                        value={field.value}
                      />
                    )}
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <Label className="form-label">Invoice Prefix (ex: INV)</Label>
                <input
                  type="text"
                  className="form-control"
                  {...register("invprefix")}
                />
              </Col>

              {/* Row 7: Invoice Suffix | Quantity Name */}
              <Col md="6">
                <Label className="form-label">
                  Invoice Next Number (ex: 100){" "}
                </Label>
                <input
                  type="number"
                  className="form-control"
                  min={1}
                  {...register("invsuffix")}
                />
              </Col>

              <Col md="6">
                <Label className="form-label">Quantity Name</Label>
                <Controller
                  name="QuantityName"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <Typeahead
                      options={[{ label: "Quantity", value: "Quantity" }]}
                      onChange={(v) => field.onChange(v)}
                      value={field.value}
                    />
                  )}
                />
              </Col>

              {/* Row 8: Default Due Days | Language */}
              <Col md="6">
                <Label className="form-label">Default Due Days</Label>
                <Controller
                  name="duedate"
                  control={control}
                  defaultValue={null}
                  render={({ field }) => (
                    <Typeahead
                      options={duedateOptions}
                      onChange={(v) => field.onChange(v)}
                      value={field.value}
                    />
                  )}
                />
              </Col>

              <Col md="6">
                <Label className="form-label">Default Language</Label>
                <Controller
                  name="language"
                  control={control}
                  defaultValue={languageOptions[0]}
                  render={({ field }) => (
                    <Typeahead
                      options={languageOptions}
                      onChange={(v) => field.onChange(v)}
                      value={field.value}
                    />
                  )}
                />
              </Col>

              {/* Row 9: Currency | Contract timeline (placeholder) */}
              <Col md="6">
                <Label className="form-label">Default Currency</Label>
                <Controller
                  name="currency"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={currencyOptions}
                      value={field.value}
                      onChange={(v) => field.onChange(v)}
                    />
                  )}
                />
              </Col>
              <Col md="6">
                <Label className="form-label">Contract Timeline (days)</Label>
                <input
                  type="number"
                  className="form-control"
                  min={0}
                  {...register("contract_timeline")}
                />
              </Col>

              {/* Row 10: Logo Upload | Icon Upload */}
              <Col md="6">
                <Label className="form-label">Logo</Label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Col md="8">
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleLogoChange}
                    />
                  </Col>
                  <Col md="4">
                    {logoPreview && (
                      <img
                        src={logoPreview}
                        alt="logo"
                        width="45"
                        height="45"
                        style={{ borderRadius: 6 }}
                      />
                    )}
                  </Col>
                </div>
              </Col>

              <Col md="6">
                <Label className="form-label">Icon</Label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Col md="8">
                    <input
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleIconChange}
                    />
                  </Col>
                  <Col md="4">
                    {iconPreview && (
                      <img
                        src={iconPreview}
                        alt="icon"
                        width="45"
                        height="45"
                        style={{ borderRadius: 6 }}
                      />
                    )}
                  </Col>
                </div>
              </Col>
            </Row>

            <FormGroup style={{ marginTop: 12 }} />
            <div className="text-end">
              <Btn attrBtn={{ color: "primary", type: "submit" }}>Submit</Btn>
            </div>
          </Form>
          <Modal isOpen={showPlanModal} centered backdrop="static">
            <ModalHeader>Choose Subscription Plan</ModalHeader>

            <ModalBody>
              <Label className="form-label">Subscription Plan</Label>

              <Typeahead
                options={packageOptions}
                value={selectedPlan}
                onChange={(v) => setSelectedPlan(v)}
                placeholder="Select a package"
              />
            </ModalBody>

            <ModalFooter>
              <Button color="primary" onClick={handleConfirmPlan}>
                Continue
              </Button>
            </ModalFooter>
          </Modal>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default NewCompany;
